import { SourceComponents } from '@updater/informant-core';
import { SecurityInput } from '@updater/ui-uds';

export const SecurityField: SourceComponents['SecurityField'] = (props) => {
  return <SecurityInput {...props} />;
};
